// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation":"PowerstreamCooperation_powerstream-cooperation___Sb6v"};